import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SimuladorHipotecaAndorra from "./pages/SimuladorHipotecaAndorra";
import AvisLegal from "./pages/AvisLegal";
import PoliticaPrivacitat from "./pages/PoliticaPrivacitat";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SimuladorHipotecaAndorra />} />
        <Route path="/avis-legal" element={<AvisLegal />} />
        <Route path="/politica-privacitat" element={<PoliticaPrivacitat />} />
      </Routes>
    </Router>
  );
}

export default App;
